import  { createContext } from 'react';
import { AutomatonTagsAction, AutomatonTagsState } from '../types';

interface ContextProps {
  state: AutomatonTagsState;
  dispatch: (action: AutomatonTagsAction) => void;
}

export const AutomatonTagsContext = createContext({} as ContextProps);
